import { Dimensions, Events, Pixel } from './Enums';
import { Tracker } from './Tracker';

export const trackClickedSearch = (data: { path: string; query: string }) => {
	Tracker.event(Events.SEARCH_RESULT, {
		event_id: data.query,
		event_name: data.path,
		search_text: data.query,
		search_result: data.path
	});
	Tracker.pixel(Pixel.SEARCH, {
		search_string: data.query
	});
};

export const trackDeletedSearch = (query: string) => {
	Tracker.event(Events.SEARCH_ABANDONED, {
		[Dimensions.SEARCH_TEXT]: query,
		event_id: query
	});
};
